import { render } from "./Banner.vue?vue&type=template&id=4a4df1c8&scoped=true&ts=true"
import script from "./Banner.ts?vue&type=script&lang=ts&external"
export * from "./Banner.ts?vue&type=script&lang=ts&external"

import "./Banner.vue?vue&type=style&index=0&id=4a4df1c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4df1c8"]])

export default __exports__